export enum AnalyticsAction {
    addToCartProducto = 'anadir_producto_cesta',
    addToCartProductoCross = 'anadir_producto_cross_cesta',
    CambioVista = 'cambio_vista',
    decrementar = 'decrementar',
    incrementar = 'incrementar',
    irCesta = 'ir_a_cesta',
    ProductClick = 'ver_producto',
    RelatedProductClick = 'ver_producto_cross',
    remove = 'eliminar_producto_wishlist',
    SeleccionarColor = 'seleccionar_color',
    seleccionarColor = 'seleccionar_color',
    SeleccionarColorProductoCross = 'seleccionar_color_producto_cross',
    seleccionarColorProductoCross = 'seleccionar_color_producto_cross',
    SeleccionarTalla = 'seleccionar_talla',
    seleccionarTalla = 'seleccionar_talla',
    SeleccionarTallaProductoCross = 'seleccionar_talla_producto_cross',
    seleccionarTallaProductoCross = 'seleccionar_talla_producto_cross',
    showShopcart = 'ver_cesta',
    showWishlist = 'ver_wishlist',
    stockError = 'error_servidor_unidadestock',
    ver_similares_sin_stock = 'ver_similares_sin_stock',
    VerAyuda = 'ver_ayuda',
    verAyuda = 'ver_ayuda',
    VerAyudaProducto = 'ver_ayuda_producto',
    verAyudaProducto = 'ver_ayuda_producto',
    verBundle = 'ver_bundle',
    verComposicion = 'ver_composicion',
    verCuidados = 'ver_cuidados',
    verDevolucion = 'ver_devolucion',
    verEnvio = 'ver_envio',
    VerGuiaTallas = 'ver_guia_tallas',
    verGuiaTallas = 'ver_guia_tallas',
    VerProductoBundle = 'ver_producto_bundle',
    verProductoBundle = 'ver_producto_bundle',
    VerVistaRapidaBundle = 'ver_vista_rapida_bundle',
    verVistaRapidaBundle = 'ver_vista_rapida_bundle',
    verVistaRapidaProducto = 'ver_vista_rapida_producto',
    VerZoom = 'ver_zoom',
    verZoom = 'ver_zoom',
}

export enum AnalyticsCF {
    ayuda = 'ayuda',
    catalog = 'catalogo',
    checkout = 'checkout',
    corporativo = 'corporativo',
    shopcart = 'shopcart',
    wishList = 'wishlist',
}

export enum AnalyticsCategory {
    backSoon = 'back_soon',
    catalog = 'catalogo',
    cesta = 'cesta',
    comingSoon = 'coming_soon',
    fichaBundle = 'ficha_bundle',
    fichaProducto = 'ficha_producto',
    minicesta = 'minicesta',
    parrilla = 'parrilla',
    relateds = 'productos_relacionados',
    sms_tiendafisica = 'sms_tiendafisica',
    ultimasTallas = 'parrilla_ultimas_tallas',
    vistaRapidaBundle = 'vista_rapida_bundle',
    wishlist = 'wishlist',
    nuevaColeccion = 'nueva_coleccion',
    search = 'buscador',
    outOfStock = 'out_of_stock',
}
